import React from "react";
import { Drawer } from "antd";
import { AiccLessonReviewScript } from "types/model/aiccLearningAssets";
import LessonScripts, { getLessonScriptTitle } from "./LessonScripts";
import styles from "./LessonReviewScript.module.scss";

interface Props {
  lesson?: AiccLessonReviewScript;
  onClose: () => void;
}

function ScriptDetailDrawer({ lesson, onClose }: Props) {
  const title = lesson && <span className={styles.drawerLesson}>{getLessonScriptTitle(lesson)}</span>;

  return (
    <Drawer title={title} width={880} visible={!!lesson} onClose={onClose} destroyOnClose>
      <LessonScripts scripts={lesson?.scripts} />
    </Drawer>
  );
}

export default ScriptDetailDrawer;
